export const SET_CREATE_CASE_LOADER = "SET_CREATE_CASE_LOADER";
export const SET_CREATE_CASE_FIELDS = "SET_CREATE_CASE_FIELDS";
export const SET_CREATE_CASE_CONTRACT_ACCOUNTS = "SET_CREATE_CASE_CONTRACT_ACCOUNTS";
export const GET_TYPE_ARR = "GET_TYPE_ARR";
export const SET_TYPE_ARR = "SET_TYPE_ARR";
export const GET_SPECIFIC_TYPE_ARR = "GET_SPECIFIC_TYPE_ARR";
export const SET_SPECIFIC_TYPE_ARR = "SET_SPECIFIC_TYPE_ARR";
export const CREATE_NEW_CASE = "CREATE_NEW_CASE";
export const SET_NEW_CASE = "SET_NEW_CASE";
export const SET_CREATE_CASE_FIELDS_ERR = "SET_CREATE_CASE_FIELDS_ERR";
export const SET_MODAL_OPEN = "SET_MODAL_OPEN";
export const SET_CANCEL_CASE_TOGGLE = "SET_CANCEL_CASE_TOGGLE";
export const SET_SUBMIT_BUTTON = "SET_SUBMIT_BUTTON";
export const SUBMIT_ATTACHMENT = "SUBMIT_ATTACHMENT";
export const ATTACHMENT_ERROR_NOTIFICATION = "ATTACHMENT_ERROR_NOTIFICATION";
export const ATTACHMENT_RESET = "ATTACHMENT_RESET";
export const ATTACHMENT_SIZE_ERROR = "ATTACHMENT_SIZE_ERROR";
export const CREATE_CASE_RESET = "CREATE_CASE_RESET";
export const ATTACHMENT_LOADER = "ATTACHMENT_LOADER";
export const ATTACHMENT_CHECK = "ATTACHMENT_CHECK";
export const CANCEL_DISABLE = "CANCEL_DISABLE";
export const DISABLE_FIELDS = "DISABLE_FIELDS";
export const TRY_AGAIN = "TRY_AGAIN";
export const FILE_STATUS_RESPONSE = "FILE_STATUS_RESPONSE";
export const FILE_NAME = "FILE_NAME";

export function setLoader(value) {
  return {
    type: SET_CREATE_CASE_LOADER,
    value,
  };
}

export function setCreateCaseFields(field, value) {
  return {
    type: SET_CREATE_CASE_FIELDS,
    field,
    value,
  };
}

export function setContractAccounts(response) {
  return {
    type: SET_CREATE_CASE_CONTRACT_ACCOUNTS,
    response,
  };
}

export function getTypeArr() {
  return {
    type: GET_TYPE_ARR,
  };
}

export function setTypeArr(response) {
  return {
    type: SET_TYPE_ARR,
    response,
  };
}

export function getSpecificTypeArr() {
  return {
    type: GET_SPECIFIC_TYPE_ARR,
  };
}

export function setSpecificTypeArr(response) {
  return {
    type: SET_SPECIFIC_TYPE_ARR,
    response,
  };
}

export function createNewCase() {
  return {
    type: CREATE_NEW_CASE,
  };
}

export function setNewCase(response) {
  return {
    type: SET_NEW_CASE,
    response,
  };
}

export function setCreateCaseFieldsErr(field, value) {
  return {
    type: SET_CREATE_CASE_FIELDS_ERR,
    field,
    value,
  };
}

export function toggleCancelCase(value) {
  return {
    type: SET_CANCEL_CASE_TOGGLE,
    value,
  };
}

export function setSubmitButton(value) {
  return {
    type: SET_SUBMIT_BUTTON,
    value,
  };
}

export function setSubmitAttachment(value) {
  return {
    type: SUBMIT_ATTACHMENT,
    value,
  };
}

export function setAttchmentErrorNotification(value) {
  return {
    type: ATTACHMENT_ERROR_NOTIFICATION,
    value,
  };
}

export function setAttachmentReset(value) {
  return {
    type: ATTACHMENT_RESET,
    value,
  };
}

export function setAttachmentFileSizeError(value) {
  return {
    type: ATTACHMENT_SIZE_ERROR,
    value,
  };
}

export function setAttachmentLoader(value) {
  return {
    type: ATTACHMENT_LOADER,
    value,
  };
}

export function setAttachmentCheck(value) {
  return {
    type: ATTACHMENT_CHECK,
    value,
  };
}

export function setCancelDisable(value) {
  return {
    type: CANCEL_DISABLE,
    value,
  };
}

export function setTryAgain(value) {
  return {
    type: TRY_AGAIN,
    value,
  };
}

export function setDisableFields(value) {
  return {
    type: DISABLE_FIELDS,
    value,
  };
}

export function setModalOpen(value) {
  return {
    type: SET_MODAL_OPEN,
    value,
  };
}

export function reset() {
  return {
    type: CREATE_CASE_RESET,
  };
}

export function setFileStatusResponse(value) {
  return {
    type: FILE_STATUS_RESPONSE,
    value,
  };
}

export function setFileName(value) {
  return {
    type: FILE_NAME,
    value,
  };
}
